import { FireflyButton } from '@equip.health/ui';

import { ProviderAlert } from '~/lib/types/providerDashboard';

import { isUnreadAlert } from './alerts.util';

interface AlertActionsProps {
  alert: ProviderAlert;
  isDisabled: boolean;
  isReviewing: boolean;
  onReview: (alert: ProviderAlert) => void;
}

const AlertActions = ({
  alert,
  isDisabled,
  isReviewing,
  onReview,
}: AlertActionsProps) => {
  const isUnread = isUnreadAlert(alert);

  return (
    <FireflyButton
      id={`alert-review-${alert.signalId}`}
      isDisabled={isDisabled}
      isLoading={isReviewing}
      onClick={() => onReview(alert)}
      size="small"
      variant={isUnread ? 'secondary' : 'tertiary'}
    >
      {isUnread ? 'View next steps' : 'Review'}
    </FireflyButton>
  );
};

export default AlertActions;
